export enum AttachmentTypeEnum {
  Video = 1,
  Audio = 2,
  Image = 3,
  Pdf = 4,
  Office = 5,
  Html = 99,
}
